import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddSoftAsset = createAsyncThunk(
  "asset/AddSoftAsset",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/soft-asset-create/`, data)
    return response.data
  }
); 

export const UpdateSoftAsset = createAsyncThunk(
  "asset/UpdateSoftAsset",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/soft-asset-update/${data.id}/`, data)
    return response.data
  }
);

export const GetSoftAssetList = createAsyncThunk(
  "asset/GetSoftAssetList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/soft-asset-list/`)
    return data
  }
);

export const GetSoftAssetDetail = createAsyncThunk(
  "asset/GetSoftAssetDetail",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/soft-asset-detail/${id}/`)
    return data
  }
);


export const DeleteSoftAsset = createAsyncThunk(
  "asset/DeleteSoftAsset",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/soft-asset-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

